import { Link } from "react-router-dom";


const ProductPackage = () => {
  return (
    <section>
      <div className="container-fluid">
        <div className="row">
          

          <div className="col-lg-10 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-1 text-end">
                <Link to="/">
                  <h6>
                    <i class="fa fa-home" aria-hidden="true"></i>Home
                  </h6>
                </Link>
              </div>
              /
              <div className="col-lg-5">
                <h6>Packages</h6>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4>Packages Amounts View</h4>
                </div>

                <div className="card-body text-center">
                  <div className="col-lg-10 ">
                    <div className="row ">


                      {/* =======================Basic Products start================= */}
{/* 
                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">Basic Products</h5>
                            <h5 className="mt-2">After Distribution:560</h5>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              View Here
                            </Link>

                            
                          </div>
                        </div>
                      </div> */}

                      {/* =======================Basic Products end================= */}

                      {/* =======================Premium Products start================= */}

                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">Premium Products</h5>
                            <h5 className="mt-2">After Distribution:999</h5>

                            <Link
                              to="/DetailsClick"
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              View Here
                            </Link>

                           
                          </div>
                        </div>
                      </div>

                      {/* =======================Premium Products end================= */}

                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductPackage;
